"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./MemberHeader.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NotificationItem = _interopRequireDefault(require("../../gradifui/components/header/NotificationItem"));

var _LabelledItem = _interopRequireDefault(require("../../gradifui/components/header/LabelledItem"));

var _BaseHeader = _interopRequireDefault(require("../../gradifui/components/header/BaseHeader"));

var _UserItem = _interopRequireDefault(require("../../gradifui/components/header/UserItem"));

var _LogoItem = _interopRequireDefault(require("../../gradifui/components/header/LogoItem"));

var _constants = require("../../util/constants");

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MemberHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(MemberHeader, _React$Component);

  var _super = _createSuper(MemberHeader);

  function MemberHeader() {
    _classCallCheck(this, MemberHeader);

    return _super.apply(this, arguments);
  }

  _createClass(MemberHeader, [{
    key: "_getAccountsHeader",
    value: function _getAccountsHeader() {
      return /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "accounts",
        icon: "icon-bank",
        label: "My Accounts",
        url: _constants.URLS.MEMBER.MY_ACCOUNTS
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$notificat, _this$props$selected, _this$props$unreadNot, _memberFeatures$hasLe, _memberFeatures$hasRe, _memberFeatures$hasPs, _memberFeatures$hasAc, _session$isLoggedIn, _session$isImpersonat, _session$user, _session$featureToggl, _session$featureToggl2, _memberFeatures$slp, _memberFeatures$saveU;

      var _this$props = this.props,
          session = _this$props.session,
          memberFeatures = _this$props.memberFeatures;
      var notificationCount = (_this$props$notificat = this.props.notificationCount) !== null && _this$props$notificat !== void 0 ? _this$props$notificat : 0;
      var selected = (_this$props$selected = this.props.selected) !== null && _this$props$selected !== void 0 ? _this$props$selected : "";
      var unreadNotificationCount = (_this$props$unreadNot = this.props.unreadNotificationCount) !== null && _this$props$unreadNot !== void 0 ? _this$props$unreadNot : 0;
      var hasLearningCenter = (_memberFeatures$hasLe = memberFeatures === null || memberFeatures === void 0 ? void 0 : memberFeatures.hasLearningCenter) !== null && _memberFeatures$hasLe !== void 0 ? _memberFeatures$hasLe : false;
      var hasRefi = (_memberFeatures$hasRe = memberFeatures === null || memberFeatures === void 0 ? void 0 : memberFeatures.hasRefi) !== null && _memberFeatures$hasRe !== void 0 ? _memberFeatures$hasRe : false;
      var hasPslf = (_memberFeatures$hasPs = memberFeatures === null || memberFeatures === void 0 ? void 0 : memberFeatures.hasPslf) !== null && _memberFeatures$hasPs !== void 0 ? _memberFeatures$hasPs : false;
      var hasAccountChoices = (_memberFeatures$hasAc = memberFeatures === null || memberFeatures === void 0 ? void 0 : memberFeatures.hasAccountChoices) !== null && _memberFeatures$hasAc !== void 0 ? _memberFeatures$hasAc : false;
      var isLoggedIn = (_session$isLoggedIn = session === null || session === void 0 ? void 0 : session.isLoggedIn) !== null && _session$isLoggedIn !== void 0 ? _session$isLoggedIn : false;
      var isImpersonating = (_session$isImpersonat = session === null || session === void 0 ? void 0 : session.isImpersonating) !== null && _session$isImpersonat !== void 0 ? _session$isImpersonat : false;
      var user = (_session$user = session === null || session === void 0 ? void 0 : session.user) !== null && _session$user !== void 0 ? _session$user : {};
      var notificationCenter = (_session$featureToggl = session === null || session === void 0 ? void 0 : (_session$featureToggl2 = session.featureToggles) === null || _session$featureToggl2 === void 0 ? void 0 : _session$featureToggl2.notificationCenter) !== null && _session$featureToggl !== void 0 ? _session$featureToggl : false;
      var canManageAccounts = memberFeatures === null || memberFeatures === void 0 ? void 0 : memberFeatures.canManageAccounts;
      var hasTuitionReimbursement = memberFeatures === null || memberFeatures === void 0 ? void 0 : memberFeatures.hasTuitionReimbursement;
      var hasHistory = (memberFeatures === null || memberFeatures === void 0 ? void 0 : memberFeatures.hasMatchHistory) || (memberFeatures === null || memberFeatures === void 0 ? void 0 : memberFeatures.hasReimbursementHistory) || (memberFeatures === null || memberFeatures === void 0 ? void 0 : (_memberFeatures$slp = memberFeatures.slp) === null || _memberFeatures$slp === void 0 ? void 0 : _memberFeatures$slp.hasFundedTransactions) || (memberFeatures === null || memberFeatures === void 0 ? void 0 : (_memberFeatures$saveU = memberFeatures.saveUp) === null || _memberFeatures$saveU === void 0 ? void 0 : _memberFeatures$saveU.hasFundedTransactions);
      return /*#__PURE__*/_react.default.createElement(_BaseHeader.default, {
        selectedHeaderItem: selected
      }, /*#__PURE__*/_react.default.createElement("nav", {
        className: "left-section"
      }, /*#__PURE__*/_react.default.createElement(_LogoItem.default, {
        url: _constants.URLS.MEMBER.DASHBOARD
      }), /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "dashboard",
        icon: "icon-gauge",
        label: "Dashboard",
        url: _constants.URLS.MEMBER.DASHBOARD
      }), (canManageAccounts || hasTuitionReimbursement || hasHistory) && this._getAccountsHeader(), hasLearningCenter && /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "learning",
        icon: "icon-book",
        label: "Learn",
        url: _constants.URLS.MEMBER.LEARNING_CENTER
      }), hasRefi && /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "refi",
        icon: "icon-sliders",
        label: "Refinancing",
        url: _constants.URLS.MEMBER.REFINANCING
      }), hasPslf && /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "pslf",
        icon: "icon-handshake-angle-solid",
        label: "Loan Forgiveness",
        url: _constants.URLS.MEMBER.PSLF
      })), /*#__PURE__*/_react.default.createElement("nav", {
        className: "right-section"
      }, isLoggedIn && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, notificationCenter && notificationCount > 0 && /*#__PURE__*/_react.default.createElement(_NotificationItem.default, {
        name: "notifications",
        notificationCount: unreadNotificationCount
      }), /*#__PURE__*/_react.default.createElement(_UserItem.default, {
        user: user,
        isImpersonating: isImpersonating,
        showChildrenOnHover: true
      }, /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "account",
        label: "Profile Settings",
        url: _constants.URLS.MEMBER.PROFILE
      }), hasAccountChoices && /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "accounts",
        label: "Switch Account",
        url: "/session/accounts"
      }), /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "external-help",
        label: "Help",
        url: _constants.URLS.EXTERNAL.HELP.MEMBER
      }), /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "help",
        label: "Contact Us",
        url: _constants.URLS.MEMBER.CONTACT
      }), /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        label: "Log Out",
        url: "/logout"
      }))), !isLoggedIn && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "external-help",
        icon: "icon-help",
        label: "Help",
        url: _constants.URLS.EXTERNAL.HELP.MEMBER
      }), /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        name: "help",
        label: "Contact Us",
        url: _constants.URLS.MEMBER.CONTACT
      }), /*#__PURE__*/_react.default.createElement(_LabelledItem.default, {
        label: "Log In",
        url: "/login"
      }))));
    }
  }]);

  return MemberHeader;
}(_react.default.Component);

_defineProperty(MemberHeader, "propTypes", {
  selected: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)])
});

var _default = (0, _Propulator.default)(MemberHeader, {
  sessionStore: ["session", "memberFeatures", "unreadNotificationCount", "notificationCount"]
});

exports.default = _default;